import { TopLevelCategories } from '../enums';

export const TopLevelCategoryBasePath: {
  [categoryId: number]: string;
} = {
  [TopLevelCategories.FixedBenefits]: '/my-account/my-benefits',
  [TopLevelCategories.FlexibleBenefits]: '/flexible-benefits',
  [TopLevelCategories.BenefitClub]: '/club-benefits',
  [TopLevelCategories.Cashback]: '/cashback',
  [TopLevelCategories.DiscountVouchers]: '/discount-vouchers',
};

export const paymentMethodCodes = {
  benefitBudget: 'free_checkout',
  mobilpay: 'mobilpay',
  mobilpaycv: 'mobilpaycv',
  mobilpaygv: 'mobilpaygv',
  mobilpaytv: 'mobilpaytv',
  salaryDeduction: 'salary_deduction',
  cashclub: 'cashclub',
};

export const onlineFilter = 89;

export const TaxPayer = {
  Employee: 'employee',
  Employer: 'employer',
};

export const FALLBACK_CATEGORY_ID = 12222;

export const ProductTypeSlugs: { [productTypeId: number]: string } = {
  1: 'services',
  2: 'gift-cards',
  3: 'discount-vouchers',
  4: 'vouchers',
};

export const getProductTypeIdBySlug = (slug?: string): number | undefined => {
  const entry = Object.entries(ProductTypeSlugs).find(([, s]) => s === slug);
  return entry ? Number(entry[0]) : undefined;
};

export const getCategoryFallbackPath = () =>
  `/club-benefits/${FALLBACK_CATEGORY_ID}`;
